const getDetailsLink = (
    searchIdentifier?: string,
    listingUris?: { detail?: string | null } | null,
    parentListingId?: string
) => {
    const detail = listingUris?.detail;

    if (!detail) {
        return '#';
    }

    const url = new URL(detail, 'https://www.zoopla.co.uk');

    if (parentListingId) {
        url.searchParams.set('parent_listing_id', parentListingId);
    }

    if (searchIdentifier) {
        url.searchParams.set('search_identifier', searchIdentifier);
    }

    const { pathname, searchParams } = url;

    return searchParams ? `${pathname}?${searchParams}` : pathname;
};

export { getDetailsLink };
